import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClassService } from 'src/app/core/services/class.service';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.css']
})
export class UploadDialogComponent implements OnInit {

  public uploadForm: FormGroup;

  public initiateFileUploading: boolean = true;
  public isUploading: boolean = false;
  public isUploadingSuccess: boolean = false;
  public isUploadingError: boolean = false;
  public isUploadingPreview: boolean = false;
  public isUploadAnotherFile: boolean = false;

  public isApiInProgress: boolean = false;

  public isFileSizeError: boolean = false;
  public isFileFormateError: boolean = false;

  public errorMsg: string = '';
  public maxFileSizeInMb: number = 20;

  public uploadPercentage: number = 0;
  public nextPercentageValue: number = 15;

  public interValCountDown: any = null;

  constructor(
    private _formBuilder: FormBuilder,
    private classService: ClassService,
    private _eventHandlingService: EventHandlingService,
    private dialogRef: MatDialogRef<UploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.initUploadForm();
  }

  initUploadForm = () => {
    this.uploadForm = this._formBuilder.group({
      file: new FormControl('', [Validators.required]),
      fileName: new FormControl('', [Validators.required])
    })
  }

  get f() {
    return this.uploadForm.controls;
  }

  onDocumentChanged = (inputEvent: any) => {
    this.isUploading = true;
    this.initiateFileUploading = false;
    this.isFileSizeError = false;
    this.isFileFormateError = false;
    this.isUploadingError = false;
    this.isUploadingSuccess = false;
    this.isUploadAnotherFile = false;

    this.calculateUploadPercentage();

    this.errorMsg = ''


    if (inputEvent.target.files.length > 0) {
      const _file = inputEvent.target.files[0];
      const _fileName = _file.name;
      const _fileSizeInMb = parseFloat((_file.size / (1024 * 1024)).toFixed(2));

      if (_fileSizeInMb <= 20) {
        const _fileExt = this.getFileExtention(_fileName);
        if (this.data.uploadExtList.includes(_fileExt)) {
          this.uploadForm.patchValue({
            file: _file,
            fileName: _fileName
          });
          this.showProgressLoader();
        } else {
          inputEvent.target.value = "";
          this.errorMsg = 'The selected file format is not supported.';
          this.isFileFormateError = true;
          this.isUploadingError = true;
          this.isUploading = false;
        }
      } else {
        inputEvent.target.value = "";
        this.errorMsg = 'Your file size exceeds the maximum size limit of ' + this.maxFileSizeInMb + 'MB'
        this.isUploadingError = true;
        this.isFileSizeError = true;
        this.isUploading = false;
      }
    }
  }

  getUploadErrorInfoText = () => {
    if (this.isFileSizeError) {
      return 'Please select a file with max size upto 20MB'
    } else if (this.isFileFormateError) {
      let _extText = this.data.uploadExtList.map((x: any) => '.' + x).join(',');

      if (this.data.uploadExtList.length > 1) {
        return "Supported formats: " + _extText;
      } else if (this.data.uploadExtList.length > 0) {
        return "Supported format: " + _extText;
      } else {
        return ''
      }
    } else {
      return ''
    }
  }

  getFileExtention = (_fileName: string = "") => {
    return (/[.]/.exec(_fileName)) ? /[^.]+$/.exec(_fileName)[0].toLowerCase() : undefined;
  }

  calculateUploadPercentage = () => {
    this.uploadPercentage = 0;
    this.nextPercentageValue = 15;
    this.interValCountDown = setInterval(() => {
      if (this.uploadPercentage < 100) {
        if (this.uploadPercentage <= 30) {
          this.uploadPercentage += this.nextPercentageValue;
        } else if (this.uploadPercentage >= 45 && this.uploadPercentage < 80) {
          if (this.uploadPercentage == 45) {
            this.nextPercentageValue = Math.floor(this.nextPercentageValue / 2);
          }
          this.uploadPercentage = Math.round(this.uploadPercentage + this.nextPercentageValue);
        } else {
          if (this.nextPercentageValue < 1) {
            this.nextPercentageValue = 1
          } else {
            this.nextPercentageValue = this.nextPercentageValue / 2;
          }
          let _calValue = Math.floor(this.uploadPercentage + this.nextPercentageValue);
          if (_calValue < 99) {
            this.uploadPercentage = Math.round(this.uploadPercentage + this.nextPercentageValue);
          } else {
            clearInterval(this.interValCountDown);
          }
        }
      }
    }, 1000)
  }

  showProgressLoader = () => {
    setTimeout(() => {
      this.uploadPercentage = 100;
      this.isUploading = false;
      this.isUploadingSuccess = true;
    }, 5000);
  }

  uploadDocument = () => {
    this.isApiInProgress = true;

    if (this.uploadForm.valid) {
      const _formData: any = new FormData();

      _formData.append('file', this.uploadForm.get('file').value);
      _formData.append('fileName', this.uploadForm.get('fileName').value);
      _formData.append('type', this.data.uploadType);
      _formData.append('isAdminUpload', false);

      this.classService.uploadMedia(this.data.classInfo.id, _formData).subscribe(
        (_res)=>{
          console.log("Success Response: ", _res);
          this._eventHandlingService.changeAction({ type: 'loadClass'});
          if(this.data.type == 'single'){
            this.cancelUploading()
          }
          setTimeout(() => {
            this.isApiInProgress = false;
            this.isUploadingSuccess = false;
            this.initiateFileUploading = true;
            this.isUploadAnotherFile = true;
          }, 2000);
        },
        (_err: any)=>{
          console.log("Uploading Error: ", _err);
          this.isApiInProgress = false;
          this.isUploadingSuccess = false;
          this.isUploadingError = true;
        }
      )
    } else {
      alert("Error! Unable to upload")
      this.initiateFileUploading = true;
    }
  }

  cancelUploading = () => {
    this.dialogRef.close();
  }
}
